import ExpandingInfo from "./expandingInfoItem";

export { ExpandingInfo };

export default ExpandingInfo;

// Init blocks
const infoBlocks = document.querySelectorAll(
	".wp-block-lsi-lsi-expanding-info-block:not([id^='expanding-info-content-'])",
);

infoBlocks.forEach((info) => {
	new ExpandingInfo(info);
});
